// Adds a class named animate to elements with the animate-el class when it's 200px in the viewport, no jQuery
const animateEls = document.querySelectorAll('.animate-el')
function checkAnimation() {
    if (!animateEls) return

    animateEls.forEach((el) => {
        const rect = el.getBoundingClientRect()
        const elTop = rect.top
        const elBottom = rect.bottom
        // const halfElHeight = el.offsetHeight / 2
        // 50px from the top of the element
        let elFromTop

        if (window.innerWidth < 768) {
            elFromTop = 50
        } else {
            elFromTop = 180
        }

        if (elTop <= window.innerHeight - elFromTop && elBottom >= 0) {
            el.classList.remove('opacity-0')
            setTimeout(() => {
                el.classList.add('animate')
                el.classList.remove('opacity-0', 'translate-y-8', '[&.animate]:translate-y-0')
            }, 100)
        }
    })
}
document.addEventListener('DOMContentLoaded', checkAnimation)
window.addEventListener('scroll', checkAnimation)

// Animerar gradienten på ai-knappar
function animateGradient() {
    const elements = document.querySelectorAll('.anime-me')
    if (!elements) return
    elements.forEach((element) => {
        const button = element.closest('a') // Hämta den omslutande knappen
        const rect = button.getBoundingClientRect() // Knappens mått
        const centerX = rect.width / 2 // Knappens mittpunkt (x)
        const centerY = rect.height / 2 // Knappens mittpunkt (y)
        const radius = Math.min(centerX, centerY) - 8 // Radie nära kanten (-5 för lite marginal)

        let angle = 0
        const speed = 0.5 // Sänk hastigheten genom att minska steget

        const updateGradient = () => {
            // Uppdatera vinkeln långsammare
            angle = (angle + speed) % 360

            // Beräkna positionen längs kanten
            const edgeX = centerX + Math.cos((angle * Math.PI) / 180) * radius
            const edgeY = centerY + Math.sin((angle * Math.PI) / 180) * radius

            // Omvandla kantens koordinater till procent
            const percentX = (edgeX / rect.width) * 100
            const percentY = (edgeY / rect.height) * 100

            // Uppdatera CSS-variabler
            element.style.setProperty('--angle', `${angle}deg`)
            element.style.setProperty('--x', `${percentX}%`)
            element.style.setProperty('--y', `${percentY}%`)

            // Fortsätt animeringen
            requestAnimationFrame(updateGradient)
        }

        updateGradient()
    })
}

// Starta animationen
animateGradient()
